<h2 *ngIf="isNewPost" mat-dialog-title>
  {{ "brand.campaign.contentCalendarImagePost.createTitle" | translate }}
</h2>
<h2 *ngIf="!isNewPost" mat-dialog-title>
  {{ "brand.campaign.contentCalendarImagePost.updateTitle" | translate }}
</h2>
<mat-dialog-content>
  <form>
    <div class="section upload-image">
      <p class="section__title">
        {{ "brand.campaign.contentCalendarImagePost.image" | translate }}
        <app-tooltip
          text="{{
            'brand.campaign.contentCalendarImagePost.linkedInImageToolTip'
              | translate
          }}"
        ></app-tooltip>
      </p>
      <img *ngIf="!!post?.image" class="item-img" [src]="post.image" />
      <app-file-uploader
        [uploaderTitle]="
          'brand.campaign.contentCalendarCarouselPost.dragDropImage' | translate
        "
        uploaderSubtitle="{{
          'brand.campaign.contentCalendarCarouselPost.dragDropImage' | translate
        }} {{ uploaderMimeTypes }}"
        (fileAddedToQueue)="fileAddedToQueue($event)"
        (apiResponse)="handleImageUploadResponse($event)"
        [uploadUrl]="uploaderUrl"
        [uploadData]="uploadData"
        [acceptFormat]="acceptFormat"
        [maxFileSize]="MAX_FILE_SIZE"
        (uploadError)="fileUploaderErrorHandler($event)"
        [responseMapper]="fileUploaderResponseMapper"
      />
    </div>
    <app-brand-campaign-content-form-post-suggested-text
      *ngIf="allValidPostTags"
      [platform]="LINKEDIN"
      [text]="post.text"
      [postTags]="allValidPostTags"
      [type]="campaign.type"
      (textChanged)="textChanged($event)"
    >
    </app-brand-campaign-content-form-post-suggested-text>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <app-content-creation-dialog-actions
    [creationMode]="isNewPost"
    [isSaving]="isSaving"
    [isSaveDisabled]="isSaveDisabled"
    (cancel)="onActionCancel()"
    (save)="onActionSave()"
    (preview)="onActionPreview()"
  ></app-content-creation-dialog-actions>
</mat-dialog-actions>
